/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-duplicates */
/* eslint-disable camelcase */
import React, { FC, useEffect, useMemo, useState } from 'react'
import {
  Text,
  Flex,
  Box,
  Stack,
  Divider,
  List,
  ListItem,
  Center,
  Spinner,
  useToast
} from '@chakra-ui/react'
import FullCalendar, {
  DateSelectArg,
  DatesSetArg,
  EventClickArg,
  EventContentArg,
  EventHoveringArg
} from '@fullcalendar/react'
import pt from '@fullcalendar/core/locales/pt-br'
import es from '@fullcalendar/core/locales/es-us'
import en from '@fullcalendar/core/locales/en-au'
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'
import { apiAuth } from '../../services/apiAuth'
import { BlocksData } from '../../hooks/scheduling/useScheduling'

interface Scheduling {
  id: number
  guide: number
  patient_id: number
  scheduled_arrival_time: string
  scheduled_initial_time: string
  scheduled_final_time: string
  real_arrival_time: string
  real_initial_time: string
  real_final_time: string
  status: number
  professional_id: number
  attendance_spot_id: number
  observation: string
  observation_payment: string
  value_to_income: number
  invoice_number: number | null
  invoice_date: string | null
  block_guide: boolean
  is_active: boolean
  specialist_name: string | null
  patient_name: string | null
  specialist_color: string | null
  patient_social_name: string | null
  attendance_items_exclude?: Array<number>
  ticket_status_payment?: number | null
  attendance_items: Array<{
    id: number
    service_name: string
    service_id: number
  }>
  attendance_spot: {
    id: number
    index: number
    name: string
    is_active: boolean
  }
}

type Services = Array<{
  id: number
  service_name: string
  service_id: number
}>

interface EventsScheduling {
  idAttendance: number
  start: string
  end: string
  title: string
  update: string
  patient_name?: string
  specialist_name?: string | SpecialistData[]
  color?: string
  specialist_color?: string
  isBlock?: boolean
  description?: string
  name?: string
  guide?: number
}

interface ViewDayTimelineProps {
  initialDate: string
  data: Array<Scheduling> | undefined
  block: Array<BlocksData> | undefined
  setStartAt: React.Dispatch<React.SetStateAction<string>>
  setEndAt: React.Dispatch<React.SetStateAction<string>>
  specialistId: String | undefined
}

interface SpecialistData {
  id: number
  name: string
  social_name: string
}

type ViewCalendar = 'timeGridDay' | 'timeGridWeek' | 'dayGridMonth' | string

let clicks: number = 0
let timer: any = setTimeout(() => {}, 750)

const BLOCK_COLOR = '#a8a2a2'

// API: 1=segunda ... 6=sábado, 7=domingo
const getApiWeekDay = (date: Date) => {
  const jsDay = date.getDay()
  return jsDay === 0 ? '7' : String(jsDay)
}

const pad = (value: number) => String(value).padStart(2, '0')

const formatDateYMD = (date: Date) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`
}

const isSameDate = (dateA: Date, dateB: Date) => {
  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  )
}

const addDays = (date: Date, days: number) => {
  const next = new Date(date)
  next.setDate(next.getDate() + days)
  return next
}

const normalizeDateOnly = (value?: string | null) => {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

const getRangeDates = (
  selectedDate: string,
  viewType: ViewCalendar
): Array<Date> => {
  const base = new Date(`${selectedDate}T00:00:00`)
  const normalized = new Date(
    base.getFullYear(),
    base.getMonth(),
    base.getDate(),
    0,
    0,
    0
  )

  if (viewType === 'timeGridDay') {
    return [normalized]
  }

  if (viewType === 'timeGridWeek') {
    const jsDay = normalized.getDay()
    const diffToMonday = jsDay === 0 ? -6 : 1 - jsDay
    const monday = addDays(normalized, diffToMonday)

    return Array.from({ length: 7 }, (_, index) => addDays(monday, index))
  }

  if (viewType === 'dayGridMonth') {
    const firstDay = new Date(
      normalized.getFullYear(),
      normalized.getMonth(),
      1
    )
    const lastDay = new Date(
      normalized.getFullYear(),
      normalized.getMonth() + 1,
      0
    )

    const days: Date[] = []
    let cursor = new Date(firstDay)

    while (cursor <= lastDay) {
      days.push(new Date(cursor))
      cursor = addDays(cursor, 1)
    }

    return days
  }

  return [normalized]
}

const buildRecurringBlockEvents = (
  eventBlock: BlocksData,
  selectedDate: string,
  viewType: ViewCalendar
): EventsScheduling[] => {
  if (!eventBlock.is_recurrent) return []
  if (!eventBlock.week_day) return []
  if (!eventBlock.recurrent_start_time || !eventBlock.recurrent_finish_time) {
    return []
  }

  const allowedDays = eventBlock.week_day
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)

  const dates = getRangeDates(selectedDate, viewType)

  return dates
    .filter((date) => allowedDays.includes(getApiWeekDay(date)))
    .map((date) => {
      const ymd = formatDateYMD(date)

      return {
        idAttendance: eventBlock.id,
        start: `${ymd}T${eventBlock.recurrent_start_time}`,
        end: `${ymd}T${eventBlock.recurrent_finish_time}`,
        title: `#${eventBlock.name || ''} - ${eventBlock.description || ''}`,
        update: `/scheduling/create`,
        patient_name: '',
        description: eventBlock.description || '',
        name: eventBlock.name || '',
        specialist_name: eventBlock.specialists,
        color: BLOCK_COLOR,
        specialist_color: BLOCK_COLOR,
        isBlock: true
      }
    })
}

const buildSingleBlockEvent = (
  eventBlock: BlocksData,
  selectedDate: string,
  viewType: ViewCalendar
): EventsScheduling[] => {
  if (eventBlock.is_recurrent) {
    return buildRecurringBlockEvents(eventBlock, selectedDate, viewType)
  }

  if (!eventBlock.start_time || !eventBlock.finish_time) {
    return []
  }

  const startDate = new Date(eventBlock.start_time)
  const finishDate = new Date(eventBlock.finish_time)

  if (Number.isNaN(startDate.getTime()) || Number.isNaN(finishDate.getTime())) {
    return []
  }

  if (viewType === 'timeGridDay') {
    const target = new Date(`${selectedDate}T00:00:00`)
    if (!isSameDate(startDate, target) && !isSameDate(finishDate, target)) {
      return []
    }
  }

  if (viewType === 'timeGridWeek') {
    const dates = getRangeDates(selectedDate, viewType)
    const belongsToWeek = dates.some(
      (date) => isSameDate(startDate, date) || isSameDate(finishDate, date)
    )
    if (!belongsToWeek) return []
  }

  if (viewType === 'dayGridMonth') {
    const base = new Date(`${selectedDate}T00:00:00`)
    const sameMonth =
      startDate.getFullYear() === base.getFullYear() &&
      startDate.getMonth() === base.getMonth()

    if (!sameMonth) return []
  }

  return [
    {
      idAttendance: eventBlock.id,
      start: eventBlock.start_time,
      end: eventBlock.finish_time,
      title: `#${eventBlock.name || ''} - ${eventBlock.description || ''}`,
      update: `/scheduling/create`,
      patient_name: '',
      description: eventBlock.description || '',
      name: eventBlock.name || '',
      specialist_name: eventBlock.specialists,
      color: BLOCK_COLOR,
      specialist_color: BLOCK_COLOR,
      isBlock: true
    }
  ]
}

export const ViewDayTimeline: FC<ViewDayTimelineProps> = ({
  initialDate,
  data,
  setEndAt,
  setStartAt,
  specialistId,
  block
}) => {
  const toast = useToast()
  const { decodeToken } = useAuth()
  const [date, setDate] = useState(initialDate)
  const [dateClick, setDateClick] = useState('')
  const [events, setEvents] = useState<EventsScheduling[] | undefined>([])
  const [typeView, setTypeView] = useState<ViewCalendar>('timeGridDay')
  const [showPopover, setShowPopover] = useState(false)
  const [guide, setGuide] = useState<any>('')
  const [patientName, setPatientName] = useState('')
  const [specialistName, setSpecialistName] = useState('')
  const [services, setServices] = useState<Services>([])
  const [statusPayment, setStatusPayment] = useState<number | null | undefined>(
    null
  )
  const [color, setColor] = useState('blue.300')

  const [showPopoverBlock, setShowPopoverBlock] = useState(false)
  const [name, setName] = useState<any>('')
  const [description, setDescription] = useState('')
  const [specialists, setSpecialists] = useState<SpecialistData[]>([])
  const [colorBlock] = useState(BLOCK_COLOR)
  const [isLoadingInfos, setIsLoadingInfos] = useState(false)
  const locale = navigator.language
  const history = useHistory()

  const reset = () => {
    clicks = 0
    timer = setTimeout(() => {}, 750)
    setDateClick('')
  }

  const calendarEvents = useMemo(() => {
    const attendanceEvents: EventsScheduling[] =
      data?.map((event) => ({
        idAttendance: event.id,
        start: event.scheduled_initial_time,
        end: event.scheduled_final_time,
        title:
          typeView === 'timeGridDay'
            ? `#${event.guide || ''} - ${
                event.patient_name || event.patient_social_name
              }`
            : `${event.patient_social_name || event.patient_name}`,
        update: `/scheduling/update/${event.id}`,
        patient_name: event.patient_name || '',
        specialist_name: event.specialist_name || '',
        color: event.specialist_color || undefined,
        specialist_color: event.specialist_color || undefined,
        guide: event.guide
      })) || []

    const blockEvents =
      block?.flatMap((eventBlock) =>
        buildSingleBlockEvent(eventBlock, initialDate, typeView)
      ) || []

    return [...attendanceEvents, ...blockEvents]
  }, [data, block, initialDate, typeView])

  useEffect(() => {
    setEvents(calendarEvents)
    setDate(initialDate)
  }, [calendarEvents, initialDate])

  const datesSet = (arg: DatesSetArg) => {
    setStartAt(arg.startStr)
    setEndAt(arg.endStr)
  }

  const handlerDataClick = (arg: DateClickArg) => {
    clicks++
    setDateClick(arg.dateStr)

    if (clicks === 1) {
      timer = setTimeout(() => {
        reset()
      }, 750)
    }

    if (clicks === 2) {
      timer = setTimeout(() => {
        history.push('/scheduling/create', {
          id: specialistId,
          selectedDate: dateClick || arg.dateStr
        })
        reset()
      }, 750)
    }
  }

  const EventClick = (arg: EventClickArg) => {
    if (arg?.event?._def?.extendedProps?.isBlock) {
      toast({
        duration: 3000,
        status: 'info',
        title: 'Atenção!',
        description: 'Para esses especialistas esses horários estão bloqueados.'
      })

      history.push(arg.event._def.extendedProps.update)
      return
    }

    history.push(arg.event._def.extendedProps.update)
  }

  const select = (arg: DateSelectArg) => {
    console.log(arg)
  }

  const changeContentView = (arg: EventContentArg) => {
    if (typeView !== arg.view.type) {
      setTypeView(arg.view.type)
    }
  }

  const eventHoveringItem = async (arg: EventHoveringArg) => {
    if (arg?.event?._def?.extendedProps?.isBlock) {
      setName(arg?.event?._def?.extendedProps?.name || '')
      setDescription(arg?.event?._def?.extendedProps?.description || '')
      setSpecialists(arg?.event?._def?.extendedProps?.specialist_name || [])
      setShowPopoverBlock(true)
      return
    }

    setColor(arg?.event?._def?.extendedProps?.specialist_color)
    setShowPopover(true)
    setIsLoadingInfos(true)
    const id = arg?.event?._def?.extendedProps?.idAttendance

    clearTimeout(timer)

    timer = setTimeout(async () => {
      try {
        const { data: attendanceInfos } = await apiAuth.get(
          `clinics/attendances/${id}/`,
          {
            params: {
              onlyFields:
                'guide,ticket_status_payment,attendance_items,patient_name,patient_social_name,specialist_name'
            }
          }
        )

        setGuide(attendanceInfos?.guide)
        setPatientName(
          attendanceInfos?.patient_name || attendanceInfos?.patient_social_name
        )
        setSpecialistName(attendanceInfos?.specialist_name)
        setStatusPayment(attendanceInfos?.ticket_status_payment)
        setServices(attendanceInfos?.attendance_items)
      } catch (error: any) {
        console.log(error)
      } finally {
        setIsLoadingInfos(false)
      }
    }, 650)
  }

  const eventHoveringItemLeave = (_arg: EventHoveringArg) => {
    setShowPopover(false)
    setShowPopoverBlock(false)
  }

  return (
    <>
      <FullCalendar
        plugins={[
          dayGridPlugin,
          bootstrap5Plugin,
          timeGridPlugin,
          interactionPlugin
        ]}
        eventContent={changeContentView}
        eventMouseEnter={eventHoveringItem}
        eventMouseLeave={eventHoveringItemLeave}
        locales={[pt, es, en]}
        nowIndicator
        dateClick={handlerDataClick}
        timeZone={decodeToken?.clinic?.timezone}
        navLinks
        height="auto"
        select={select}
        datesSet={datesSet}
        timeZoneParam={decodeToken?.clinic?.timezone}
        locale={decodeToken?.clinic?.language === 'pt' ? 'pt-BR' : locale}
        allDaySlot={false}
        eventClick={EventClick}
        firstDay={1}
        initialDate={date}
        initialView="timeGridDay"
        headerToolbar={{
          center: 'title',
          left: `prev,next today`,
          right: 'timeGridDay,timeGridWeek,dayGridMonth'
        }}
        themeSystem="bootstrap5"
        events={events}
      />

      {showPopover && (
        <Flex
          position="fixed"
          zIndex={999}
          right="12"
          bottom="8"
          p="4"
          bg={color !== undefined ? color : 'Highlight'}
          boxShadow="0px 4px 10px rgba(0, 0, 0, 0.32)"
          borderRadius={16}
          color="white"
          flexDirection="column"
        >
          <Box>
            <Text fontWeight="bold" fontFamily="heading" textAlign="center">
              Informações sobre a agenda
            </Text>
          </Box>
          {isLoadingInfos ? (
            <Center gap="4" p="6" px="4">
              <Text color="white">Carregando informações...</Text>
              <Spinner size="md" color="white" />
            </Center>
          ) : (
            <Stack spacing="2" direction="column" w="100%">
              <Stack
                direction="row"
                my="2"
                spacing="6"
                justifyContent="space-between"
                w="100%"
              >
                <Text>Guia:</Text>
                <Text>{guide}</Text>
              </Stack>
              <Stack
                direction="row"
                my="2"
                spacing="6"
                justifyContent="space-between"
                w="100%"
              >
                <Text>Paciente:</Text>
                <Text>{patientName}</Text>
              </Stack>
              <Stack
                direction="row"
                my="2"
                spacing="6"
                justifyContent="space-between"
                w="100%"
              >
                <Text>Especialista:</Text>
                <Text>{specialistName}</Text>
              </Stack>
              <Stack
                direction="row"
                my="2"
                spacing="6"
                justifyContent="space-between"
                w="100%"
              >
                <Text>Status de Pagamento:</Text>
                {statusPayment === 1 && <Text>Pendente</Text>}
                {statusPayment === 2 && <Text>Pago</Text>}
                {statusPayment === 3 && <Text>Parcial</Text>}
                {statusPayment === 4 && <Text>Excedente</Text>}
                {!statusPayment && <Text>Ticket não gerado</Text>}
              </Stack>
              <Divider />
              <Stack
                direction="row"
                my="2"
                spacing="6"
                w="100%"
                justifyContent="space-between"
              >
                <Text>Serviços</Text>
                <List>
                  {services?.map((item) => (
                    <ListItem textAlign="right" key={item?.id}>
                      {item.service_name}
                    </ListItem>
                  ))}
                </List>
              </Stack>
            </Stack>
          )}
        </Flex>
      )}

      {showPopoverBlock && (
        <Flex
          position="fixed"
          zIndex={999}
          right="12"
          bottom="8"
          p="4"
          bg={colorBlock !== undefined ? colorBlock : 'Highlight'}
          boxShadow="0px 4px 10px rgba(0, 0, 0, 0.32)"
          borderRadius={16}
          color="white"
          flexDirection="column"
        >
          <Box>
            <Text fontWeight="bold" fontFamily="heading" textAlign="center">
              Bloqueio de agenda
            </Text>
          </Box>
          <Stack spacing="2" direction="column" w="100%">
            <Stack
              direction="row"
              my="2"
              spacing="6"
              justifyContent="space-between"
              w="100%"
            >
              <Text>Nome:</Text>
              <Text>{name}</Text>
            </Stack>
            <Stack
              direction="row"
              my="2"
              spacing="6"
              justifyContent="space-between"
              w="100%"
            >
              <Text>Descrição:</Text>
              <Text>{description}</Text>
            </Stack>
            <Divider />
            <Stack
              direction="row"
              my="2"
              spacing="6"
              w="100%"
              justifyContent="space-between"
            >
              <Text>Especialistas Indisponíveis:</Text>
              <List>
                {specialists?.map((item) => (
                  <ListItem textAlign="right" key={item?.id}>
                    {item?.social_name}
                  </ListItem>
                ))}
              </List>
            </Stack>
          </Stack>
        </Flex>
      )}
    </>
  )
}
